import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../../context/notificationContext";
import { useI18n } from "../../../hooks/useTranslations";
import { useDueDateTypesApi } from "../../../http/dueDateTypes/api";
import ModalDialog from "../../ui/ModalDialog";

interface DeleteDueDateTypeDialogProps {
  dueDateTypeId: string;
  onClose: () => void;
}

const DeleteDueDateTypeDialog: FC<DeleteDueDateTypeDialogProps> = ({ dueDateTypeId, onClose }) => {
  const i18n = useI18n();
  const dueDateTypesApi = useDueDateTypesApi();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useContext(NotificationDispatch);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.dueDateTypes.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,

          onClick: () => {
            setIsSubmitting(true);
            dueDateTypesApi
              .deleteAdminDueDateType(dueDateTypeId)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.dueDateTypes.questions.delete}
    </ModalDialog>
  );
};

export default DeleteDueDateTypeDialog;
